<div class="modal-header d-flex justify-content-center bg-light">
  <h4 class="modal-title text-center strong">{{ 'home.productHeader.SelectProducts' | cxTranslate }}<div class="modalsubheader">{{'tenders.wishto'| cxTranslate}}</div>
  </h4>
</div>
<div class="modal-body bg-light">
    <div *ngFor="let data of productsInfo.combinedTenders;let i=index">
    <div class="card mt-3 rounded">
      <div class="card-body" [ngClass]="{'bg-gray-200': data.checked}">
          <div  class="ml-5  d-flex line-height">
            <label class="mb-0">
              <input type="checkbox" [(ngModel)]="data.checked" disabled (change)="onCheckboxChange(data,$event)"/>
<div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{i+1}}</div>
              <h5 class="strong">{{data.newName?data.newName:data.productName}}</h5>
              <div class="d-flex justify-content-between mt-2">
              <div class="row">
                <div class="col">
                <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate }}({{data.displayQuantityUnitDesc}})</div>
                <div class="strong">{{data.quantity | number}}</div>
              </div>
                <div class="col">
                  <div class="small text-secondary del">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
                  <!-- <div class=" small">{{data ?.loadPortLaycanStartDate | date:"dd/MM/yyyy"}} - {{data ?.loadPortLaycanEndDate | date:"dd/MM/yyyy"}}</div> -->
                      <div class=" small">{{data?.laycanStartDate | date:"dd/MM/yyyy"}} - {{data?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
                </div>
              </div>
              </div>
            </label>
          </div>
          
        </div>
      </div>
    </div>
</div>

<div class="modal-footer bg-light" >
    <div class="w-100">
            <button class="btn btn-block btn-primary btn-lg" id="material1"   type="submit" (click)="Openmodal()" >{{'tenders.Next'|cxTranslate}}</button>
    <button class="btn btn-block btn-lg btn-light" type="button"  (click)="ActiveModal.dismiss('close click');close()">Cancel</button>
  </div>
</div>

